<template>
    <div :id="title">
        <trading-vue
            ref="chart"
            :id="title"
            type="candles"
            :width="width"
            color-back="#ffffff"
            color-grid="#eee"
            color-text="#333"
            :timezone="0"
            :titleTxt="title"
            :data="chart_data"
            :toolbar="false"
            :chart-config="{
                DEFAULT_LEN: 1200,
            }"
        ></trading-vue>
    </div>
</template>
<script>
import {TradingVue, DataCube} from "trading-vue-js";
import helperMethods from "@/helpers";

export default {
    props:{
        width: Number,
        title: String,
        candles: Array|undefined,
        deals: Array|undefined,
        zeroPrice: String,
        timezone: Number,
        candlesChartData: Array,
    },
    components:{
        TradingVue,
    },
    data(){
        return {

        }
    },
    mounted(){

    },
    computed:{
        chart_data(){
            let candlesData;
            let dealsData;
            if(this.candlesChartData) candlesData = this.candlesChartData;
            else candlesData = this.ohlcvFromCandles(this.candles, this.zeroPrice);
            return new DataCube({
                ohlcv: candlesData,
            });
        },
    },
    methods:{
        ...helperMethods,
    }

}
</script>
